import { createApp } from 'vue';
import BootstrapVueNext from 'bootstrap-vue-next';
import VueSweetalert2 from 'vue-sweetalert2';
import { CkeditorPlugin } from '@ckeditor/ckeditor5-vue';
import VueApexCharts from 'vue3-apexcharts';
import VueFeather from 'vue-feather';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn.js';
import { vMaska } from 'maska';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import '@vueform/multiselect/themes/default.css';
import 'flatpickr/dist/flatpickr.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import './styles/theme.css';
import './styles/catalog.css';
import './styles/filter-bar.css';
import App from './App.vue';
import router from './router';

flatPickr.props.config.default = () => ({ locale: Vietnamese });
createApp(App).use(router).use(BootstrapVueNext).use(VueSweetalert2).use(CkeditorPlugin).use(VueApexCharts).component(VueFeather.type, VueFeather).component('flat-pickr', flatPickr).directive('maska', vMaska).mount('#app');
